import { COMPANY, CUSTOM_SECURITY, INDEX, INDICATOR, MODEL_PORTFOLIO, MUTUAL_FUND, SECURITYLIST, SEPARATE_ACCOUNT, } from 'Angular/constants/core.constants';
export const LINE_ANNOTATION_AREA_CHART = 'area_chart';
export const LINE_ANNOTATION_AVG = 'avg';
export const LINE_ANNOTATION_DIVIDENDS = 'dividends';
export const LINE_ANNOTATION_EARNINGS_RESULTS = 'earnings_results';
export const LINE_ANNOTATION_FORCE_ORIGINAL = 'force_original';
export const LINE_ANNOTATION_FORCE_SINGLE_PANEL = 'force_on_single_panel';
export const LINE_ANNOTATION_HIDDEN = 'hidden';
export const LINE_ANNOTATION_LINE_COLOR = 'line_color';
export const LINE_ANNOTATION_LINE_WEIGHT = 'line_weight';
export const LINE_ANNOTATION_MAX = 'max';
export const LINE_ANNOTATION_MIN = 'min';
export const LINE_ANNOTATION_SPINOFFS = 'spinoffs';
export const LINE_ANNOTATION_SPLITS = 'splits';
// Chart data formatting options
export const CHART_FORMAT_CURRENCY_GROWTH = 'currency_growth';
export const CHART_FORMAT_NORMALIZED = 'indexed';
export const CHART_FORMAT_PERCENT_OFF_HIGH = 'percent_off_high';
export const CHART_FORMAT_REAL = 'real';
// Chart scale types
export const SCALE_TYPE_LINEAR = 'linear';
export const SCALE_TYPE_LOG = 'log';
export const SERIES_TYPE_FLAGS = 'flags';
export const ANNOTATION_FLAG_TITLE_MAP = {
    [LINE_ANNOTATION_DIVIDENDS]: 'D',
    [LINE_ANNOTATION_EARNINGS_RESULTS]: 'E',
    [LINE_ANNOTATION_SPLITS]: 'S',
    [LINE_ANNOTATION_SPINOFFS]: 'S',
};
export const ANNOTATION_LINE_LABEL_INFO = {
    [LINE_ANNOTATION_MIN]: {
        label: {
            prefix: 'Low: ',
            y: 12.5,
        },
        arrow: null,
    },
    [LINE_ANNOTATION_MAX]: {
        label: {
            prefix: 'Hi: ',
            y: -10.5,
        },
        arrow: null,
    },
    [LINE_ANNOTATION_AVG]: {
        label: null,
        arrow: {
            suffix: 'AVG',
        },
    },
};
export const LINE_ANNOTATION_BOOL_KEYS = [
    LINE_ANNOTATION_AREA_CHART,
    LINE_ANNOTATION_AVG,
    LINE_ANNOTATION_DIVIDENDS,
    LINE_ANNOTATION_EARNINGS_RESULTS,
    LINE_ANNOTATION_FORCE_ORIGINAL,
    LINE_ANNOTATION_FORCE_SINGLE_PANEL,
    LINE_ANNOTATION_HIDDEN,
    LINE_ANNOTATION_MAX,
    LINE_ANNOTATION_MIN,
    LINE_ANNOTATION_SPLITS,
    LINE_ANNOTATION_SPINOFFS,
];
export const LINE_ANNOTATION_FORCE_ORIGINAL_HELP_MODAL_NAME = 'force_original_annotation_option';
export const LINE_ANNOTATION_FORCE_SINGLE_PANEL_MODAL_NAME = 'force_on_single_panel_annotation_option';
export const LINE_ANNOTATIONS_SECURITY_TYPE_ENABLED_EVENTS_MAP = {
    [COMPANY]: [
        LINE_ANNOTATION_EARNINGS_RESULTS,
        LINE_ANNOTATION_DIVIDENDS,
        LINE_ANNOTATION_SPLITS,
        LINE_ANNOTATION_SPINOFFS,
    ],
    [CUSTOM_SECURITY]: [],
    [INDEX]: [],
    [INDICATOR]: [],
    [MODEL_PORTFOLIO]: [],
    [MUTUAL_FUND]: [LINE_ANNOTATION_DIVIDENDS],
    [SECURITYLIST]: [
        LINE_ANNOTATION_EARNINGS_RESULTS,
        LINE_ANNOTATION_DIVIDENDS,
        LINE_ANNOTATION_SPLITS,
        LINE_ANNOTATION_SPINOFFS,
    ],
    [SEPARATE_ACCOUNT]: [],
};
export const CORRELATION_FIRST_SECURITY = '_firstSecurity_';
export const CORRELATION_LIST_SECURITY = '_listSecurity_';
export const CORRELATION_SECURITY_OPTIONS = [CORRELATION_FIRST_SECURITY, CORRELATION_LIST_SECURITY];
// Fund Chart Line Width
export const FUND_CHART_LINE_WEIGHT_THIN = 'thin';
export const FUND_CHART_LINE_WEIGHT_MEDIUM = 'medium';
export const FUND_CHART_LINE_WEIGHT_THICK = 'thick';
// Line Width To Label Map
export const LINE_WEIGHT_LABEL_MAP = {
    [FUND_CHART_LINE_WEIGHT_THIN]: 'Thin',
    [FUND_CHART_LINE_WEIGHT_MEDIUM]: 'Medium',
    [FUND_CHART_LINE_WEIGHT_THICK]: 'Thick',
};
